import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import  VueGoogleMaps from '@fawmi/vue-google-maps'
import axios from 'axios'

createApp(App)
.use(router, axios)
.use(VueGoogleMaps, {
    load: {
        key: 'GoogleMApsAPIKey',
    },
})
.mount('#app')
